import styled from 'styled-components';

import {Text} from '~components/atoms/Text';
import {filtersMenuWidth} from '~components/molecules/FiltersMenu/styles';
import breakpoints from '~constants/breakpoints';

export const ListPageWrapper = styled.div`
    display: flex;
    width: 100%;
    min-height: 100%;
    flex-grow: 1;
    overflow: hidden;

    ${breakpoints.abovePhone} {
        background: linear-gradient(180deg, #fafafa 0%, rgba(250, 250, 250, 0) 90%),
            #ffffff;
    }
`;

export const LandListContainer = styled.div`
    height: 100%;
    position: relative;
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;

    ${breakpoints.abovePhone} {
        margin: 64px 0 64px ${filtersMenuWidth}px;
    }
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 0 16px;

    ${breakpoints.abovePhone} {
        padding: 0 25px;
    }
`;

export const ListControls = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column-reverse;
    gap: 12px;

    ${breakpoints.abovePhone} {
        gap: 24px;
        flex-direction: row;
        align-items: center;
    }
`;

export const ListInfo = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column-reverse;
    gap: 12px;

    ${breakpoints.abovePhone} {
        gap: 24px;
        flex-direction: row;
        align-items: center;
    }
`;

export const FoundedPlotsText = styled(Text)`
    line-height: 34px;
    opacity: 0.5;
    font-size: 12px;

    ${breakpoints.abovePhone} {
        opacity: 1;
        font-size: 14px;
    }
`;

export const Sep = styled.div`
    height: 34px;
`;

export const ListContainer = styled.div`
    width: 100%;
    flex-grow: 1;

    ${breakpoints.abovePhone} {
        margin-top: 24px;
    }

    .List {
        // Required to fit 3 columns on 1440 instead of 1448 without altering paddings
        overflow-x: hidden !important;

        &::-webkit-scrollbar {
            width: 0px;
            background: transparent;
        }

        & > div {
            margin: 15px auto !important;
            position: relative !important;

            & > div {
                margin: 0px;
                padding: 8px;
            }
        }
    }
`;

export const LoaderContainer = styled.div`
    flex-grow: 1;
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ItemLoader = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
    border-radius: 24px;
`;
